import type { StateCreator } from 'zustand/vanilla';

import type { UserStore } from '../../store';

export interface CommonAction {
  /**
   * Set the user's private space ID
   */
  setPrivateSpaceId: (privateSpaceId: string) => void;
  /**
   * Clear the private space ID
   */
  clearPrivateSpaceId: () => void;
  /**
   * Set initialized state
   */
  setInitialized: (isInitialized: boolean) => void;
  /**
   * Set compliance acceptance flags during registration
   */
  setComplianceFlags: (termsAccepted: boolean, analyticsAccepted: boolean) => void;
}

export const createCommonSlice: StateCreator<UserStore, [['zustand/devtools', never]], [], CommonAction> = (set) => ({
  setPrivateSpaceId: (privateSpaceId: string) => {
    set({ privateSpaceId });
  },

  clearPrivateSpaceId: () => {
    set({ privateSpaceId: '' });
  },

  setInitialized: (isInitialized: boolean) => {
    set({ isInitialized });
  },

  setComplianceFlags: (termsAccepted: boolean, analyticsAccepted: boolean) => {
    set({ termsAccepted, analyticsAccepted });
  },
});
